import PropTypes from 'prop-types';

const MembersPropTypes = {
  users: PropTypes.string,
};

export default MembersPropTypes;
